import { IObjectKey } from "src/app/modules/shared/models/objects";

export const policy_beneficiary_keys: IObjectKey[] = [
    {
        key: 'type',
        label: 'Tipo beneficiario'
    },
    {
        key: 'fiscalCode',
        label: 'Codice fiscale'
    },
    {
        key: 'percentage',
        label: 'Quota'
    },
    {
        key: 'relationshipWithSubscriber',
        label: 'Relazione Beneficiario-Contraente'
    }
]

export const policy_beneficiary_keys_PREV: IObjectKey[] = [
    {
        key: 'type',
        label: 'Tipo beneficiario'
    },
    {
        key: 'fiscalCode',
        label: 'Codice fiscale'
    },
    {
        key: 'percentage',
        label: '% Eredità'
    },    
    {
        key: 'relationshipWithSubscriber',
        label: 'Relazione Beneficiario-Contraente'
    },
    {
        key: 'address',
        label: 'Indirizzo'
    }
]

export const isv_policy_beneficiary_keys: IObjectKey[] = [
    {
        key: 'type',
        label: 'codeChoice'
    },
    {
        key: 'fiscalCode',
        label: 'Codice fiscale'
    },
    {
        key: 'percentage',
        label: 'Quota'
    },
    {
        key: 'relationshipWithSubscriber',
        label: 'Relazione Beneficiario-Contraente'
    }
]

export const TCM_policy_beneficiary_keys: IObjectKey[] = [
    {
        key: 'type',
        label: 'Tipo beneficiario'
    },
    {
        key: 'fiscalCode',
        label: 'Codice fiscale'
    },
    {
        key: 'relationshipWithSubscriber',
        label: 'Relazione Beneficiario-Contraente'
    }
]